






















    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    class EditOrderModel {
        id: number;
        whetherHandle: boolean;
        reMark: string;
    }
    @Component
    export default class EditFreightModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        editModel: EditOrderModel = new EditOrderModel();
        addLoding = false;

        async save() {
            this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'frontorderreturn/editOrderReturn',
                        data: this.editModel
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.editForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
        }
        cancel() {
            (this.$refs.editForm as any).resetFields();
            this.$emit('input', false);
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                (this.$refs.editForm as any).resetFields();
                var data = this.$store.state.frontorderreturn.orderReturnInfo;
                this.editModel = { id: data.id, reMark: data.reMark, whetherHandle: data.whetherHandle };
            }
        }
        created() {

        }

    }
